export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const PAGING_INFO = 'PAGING_INFO';
export const SELECTED_ROW = 'SELECTED_ROW';

export default { STATE_INIT, DEFAULT_ASSIGN, SEARCH_PARAM, PAGING_INFO, SELECTED_ROW };
